export default {
    watch: {
        noteList(val) {
            if (val) {
                let list = []
                this.noteList.forEach(item => {
                    list.push(item.Id)
                })
                this.nodeIdList = list
            } else {
                this.nodeIdList = null
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/myNoteController.js